export const secrets = {
    // The following will be replaced by the build process as necessary...
    fingerprintJsToken: "JQ6ZwhxGrHjw8uJxGltt",
};
